import angular from 'angular';
import { alerts } from 'app/components/global';

import directive from './report-instances.directive';
import controller from './report-instances.controller';

import reportInstance from './reportInstance';


export default angular.module('app.components.reports.generatedReports.reportInstances', [
  alerts,
  reportInstance
])
  .directive('grReportInstances', directive)
  .controller('GRReportInstancesController', controller)
  .name;

console.log('app.components.reports.generatedReports.reportInstances created');
